/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IdtypeToadd as AgentApiContractIdtypeToadd } from '../../models/AgentApi/Contract/idtype-toadd';

export interface ApiAgentListIdtypeToaddGet$Plain$Params {

/**
 * Interface language
 */
  lang?: string;
}

export function apiAgentListIdtypeToaddGet$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentListIdtypeToaddGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListIdtypeToaddGet$Plain.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractIdtypeToadd>>;
    })
  );
}

apiAgentListIdtypeToaddGet$Plain.PATH = '/api/Agent/ListIdtypeToadd';
